import type { GameState } from "@dailywars/core/engine";

export type CachedLayer = {
  draw: (args: {
    state: GameState;
    backingWidth: number;
    backingHeight: number;
    dpr: number;
    key: unknown;
  }) => HTMLCanvasElement | null;
};

export function createCachedLayer(
  render: (ctx: CanvasRenderingContext2D, state: GameState) => void,
): CachedLayer {
  let canvas: HTMLCanvasElement | null = null;
  let cachedKey: unknown = null;
  let cachedWidth = 0;
  let cachedHeight = 0;

  return {
    draw: ({ state, backingWidth, backingHeight, dpr, key }) => {
      const reusable =
        canvas !== null &&
        Object.is(cachedKey, key) &&
        cachedWidth === backingWidth &&
        cachedHeight === backingHeight;
      if (reusable) return canvas;

      const target = canvas ?? document.createElement("canvas");
      if (target.width !== backingWidth || target.height !== backingHeight) {
        target.width = backingWidth;
        target.height = backingHeight;
      }
      const layerCtx = target.getContext("2d");
      if (!layerCtx) return null;
      layerCtx.setTransform(1, 0, 0, 1, 0, 0);
      layerCtx.clearRect(0, 0, backingWidth, backingHeight);
      layerCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
      render(layerCtx, state);

      canvas = target;
      cachedKey = key;
      cachedWidth = backingWidth;
      cachedHeight = backingHeight;
      return canvas;
    },
  };
}
